import { Divider } from "@mui/material";
import { useState } from "react";
import { NavLink, Link, useLocation } from "react-router-dom";
import styled from "@emotion/styled";
import React from "react";
import { useSelector } from "react-redux";
interface SubmenuProps {
  sidebar?: boolean;
}

const SidebarNavLink = styled(NavLink)<SubmenuProps>`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 16px 0px;
  margin: 0px 10px;
  list-style: none;
  text-decoration: none;
  font-size: 16px;
  font-weight: 600;
  border-radius: 10px;
  width: ${({ sidebar }: any) => (!sidebar ? "0px" : "220px")};
`;
const SidebarLink = styled(NavLink)`
  display: flex;
  justify-content: space-between;
  align-items: center;
  color: black;
  padding: 8px;
  margin: 5px 0px 5px 30px;
  border-radius: 4px;
  list-style: none;
  text-decoration: none;
  font-size: 15px;
  font-weight: 600;
`;

const SidebarLabel = styled.span`
  margin-left: 10px;
  font-style: normal;
  font-weight: 700;
  font-size: 16px;
  line-height: 15px;
`;
const SidebarLabelsub = styled.span`
  margin-left: 0px;
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  line-height: 15px;
`;

const SidebarTitle = styled.span`
  // font-family: 'Inter';
  font-style: normal;
  font-weight: 500;
  font-size: 17.5882px;
  line-height: 21px;
  color: #6842d9;
  padding-left: 10px;
`;

const SubMenu = ({ item, sidebar }: IInstructionSteps) => {
  const [subnav, setSubnav] = useState(false);

  const showSubnav = () => setSubnav(!subnav);
  const location = useLocation();
  const isActive = location.pathname.split("/")[1] === item.path;
  const account = useSelector((state: any) => state.auth);
 
  return (
    <>
      {item.subNav && item.subNav.length > 0 ? (
        <div>
          {sidebar ? (
            <NavLink
              className="sidebar-nav-link"
              to={item.path}
              onClick={showSubnav}
            >
              <SidebarLabel>
                {isActive ? item.icon1 : item?.icon}&nbsp; {item.title}
              </SidebarLabel>
              {/* {!subnav ? item.iconClosed : item.iconOpened} */}
            </NavLink>
          ) : (
            <div className="sidebar-nav-link">
              <SidebarLabel>
                {isActive ? item.icon1 : item?.icon}&nbsp; {item.title}
              </SidebarLabel>
            </div>
          )}
          {true &&
            item.subNav.map((subNavItem, subIndex) => {
              const hasSubAccess = subNavItem?.roles?.includes(account.roleName);
              if (!hasSubAccess) return null;
              return (
                <div className="sub-nav" key={subIndex}>
                  <SidebarLink to={subNavItem.path} key={subIndex}>
                    <div>
                      <SidebarLabelsub>
                        {" "}
                        {subNavItem.icon}&nbsp;{subNavItem.title}
                      </SidebarLabelsub>
                    </div>
                  </SidebarLink>
                </div>
              );
            })}
        </div>
      ) : item.head ? (
        <SidebarTitle>{item.head}</SidebarTitle>
      ) : (
        <>
          {sidebar ? (
            <NavLink
              className="sidebar-nav-link"
              to={item.path}
              onClick={showSubnav}
            >
              <div>
                <SidebarLabel>
                  {isActive ? item.icon1 : item?.icon}
                  &nbsp; {item.title}
                </SidebarLabel>
              </div>
            </NavLink>
          ) : (
            <div className="sidebar-nav-link">
              <SidebarLabel>
                {isActive ? item.icon1 : item?.icon}&nbsp; {item.title}
              </SidebarLabel>
            </div>
          )}
          {item.hr === "true" ? (
            <Divider style={{ margin: "8px 25px" }}></Divider>
          ) : (
            ""
          )}
        </>
      )}
    </>
  );
};

export default SubMenu;
interface IInstructionSteps {
  item: any;
  sidebar: boolean;
}
